import { useState } from "react";
import { StepNav } from "@/components/wizard/Stepper";

export const StepDetails = ({ order, go, back }) => {
  const [title, setTitle] = useState(order.title || "");
  const [message, setMessage] = useState(order.message || "");
  return (
    <div>
      <h2 className="text-3xl font-bold text-[#4A2A18]">Give your keepsake a title</h2>
      <p className="mt-3 text-lg text-[#4A3B32]">The title is printed on every sticker. The message appears on the video page.</p>
      <div className="mt-8 space-y-6">
        <div>
          <label htmlFor="title" className="label">Title (printed on stickers)</label>
          <input id="title" className="field" maxLength={40} value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Grandma's Holiday Story" data-testid="title-input" />
          <p className="mt-1 text-right text-sm text-[#8C7A6B]">{title.length}/40</p>
        </div>
        <div>
          <label htmlFor="message" className="label">Short message <span className="font-normal text-[#8C7A6B]">(optional)</span></label>
          <textarea id="message" className="field min-h-[130px]" maxLength={280} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Happy holidays, my darlings. I love you all." data-testid="message-input" />
          <p className="mt-1 text-right text-sm text-[#8C7A6B]">{message.length}/280</p>
        </div>
      </div>
      <StepNav back={back} next={() => go(3, { title, message })} disabled={!title.trim()} />
    </div>
  );
};
